var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4To7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_62384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9966 8.81846 22.7312 5.76821 20.4815 3.51852C18.2318 1.26883 15.1815 0.00344108 12 0V0ZM13 11.879C13.0001 12.0485 12.9571 12.2153 12.8751 12.3636C12.793 12.5119 12.6746 12.637 12.531 12.727L8.69101 15.127C8.57938 15.1967 8.45512 15.2438 8.3253 15.2655C8.19549 15.2872 8.06268 15.2831 7.93444 15.2535C7.8062 15.2239 7.68505 15.1693 7.57791 15.0929C7.47077 15.0164 7.37974 14.9196 7.31001 14.808C7.24027 14.6964 7.19321 14.5721 7.1715 14.4423C7.1498 14.3125 7.15387 14.1797 7.18349 14.0514C7.21311 13.9232 7.2677 13.802 7.34414 13.6949C7.42059 13.5878 7.51738 13.4967 7.62901 13.427L11 11.325V7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6C12.2652 6 12.5196 6.10536 12.7071 6.29289C12.8946 6.48043 13 6.73478 13 7V11.879Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_62384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4To7);
export default __webpack_public_path__ + "static/media/4TO7.f3812625ee8a91f4b13d3de484346650.svg";
export { ForwardRef as ReactComponent };